import { Component, Input, OnInit } from '@angular/core';
import { Count } from './count';

@Component({
  selector: 'wfm-to-do-count',
  templateUrl: './to-do-count.component.html',
  styleUrls: ['./to-do-count.component.scss']
})
export class ToDoCountComponent implements OnInit {
  @Input() counts: Count;
  @Input() showFindings?: boolean = true;

  ngOnInit() {
    this.counts = this.counts || new Count(0, 0, 0);
  }
}
